import Vue from "vue";
import Vuex from "vuex";
import request from "@/api/index";
let requestIns = new request();
Vue.use(Vuex);

interface state extends Object {
  [index: string]: any;
}
const stateOption: state = {
  Token: "",
  appId: "",
  sessionId: "",
  appInfo: [] //  在App.vue中已经获取，可直接使用    数据格式  [   { appId: 2, appName: '巫山'}, { appId: 2, appName: '巫山'}, ]
};
export default new Vuex.Store({
  state: stateOption,
  mutations: {
    SET_STATE(state, obj) {
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          (state as state)[key] = obj[key];
        }
      }
    },
    SET_appInfo(state, payload) {
      state.appInfo = payload;
    }
  },
  actions: {
    async getAppInfo({ commit }) {
      let appInfo = await requestIns.getAppInfoList();
      if (appInfo.code >= 0) {
        commit("SET_appInfo", appInfo.data);
      } else {
        commit("SET_appInfo", [
          {
            appId: 1,
            appName: "新重庆"
          },
          {
            appId: 2,
            appName: "巫山"
          },
          {
            appId: 3,
            appName: "五彩石柱"
          },
          {
            appId: 4,
            appName: "掌新南岸"
          },
          {
            appId: 5,
            appName: "巫溪"
          },
          {
            appId: 6,
            appName: "人人长寿"
          },
          {
            appId: 7,
            appName: "武隆印象"
          },
          {
            appId: 8,
            appName: "今日合川"
          },
          {
            appId: 9,
            appName: "永川头条"
          },
          {
            appId: 10,
            appName: "铜梁"
          },
          {
            appId: 11,
            appName: "爱璧山"
          },
          {
            appId: 12,
            appName: "渝北掌媒"
          },
          {
            appId: 13,
            appName: "翠翠秀山1"
          },
          {
            appId: 14,
            appName: "品位忠州"
          },
          {
            appId: 15,
            appName: "缙享北碚"
          },
          {
            appId: 16,
            appName: "爱涪陵"
          },
          {
            appId: 17,
            appName: "大美綦江"
          },
          {
            appId: 18,
            appName: "重庆垫江"
          },
          {
            appId: 19,
            appName: "重庆渝中"
          },
          {
            appId: 20,
            appName: "家在奉节"
          },
          {
            appId: 21,
            appName: "苗乡彭水"
          },
          {
            appId: 22,
            appName: "帅开州"
          },
          {
            appId: 23,
            appName: "家在梁平"
          },
          {
            appId: 24,
            appName: "酉州城事"
          },
          {
            appId: 25,
            appName: "最江津"
          },
          {
            appId: 26,
            appName: "家在黔江"
          },
          {
            appId: 27,
            appName: "重庆江北"
          },
          {
            appId: 28,
            appName: "看万州"
          },
          {
            appId: 29,
            appName: "幸福万盛"
          },
          {
            appId: 30,
            appName: "重庆荣昌"
          },
          {
            appId: 31,
            appName: "看丰都"
          },
          {
            appId: 32,
            appName: "今日南川"
          },
          {
            appId: 33,
            appName: "见十"
          },
          {
            appId: 34,
            appName: "看巴南"
          },
          {
            appId: 35,
            appName: "掌上城口"
          },
          {
            appId: 36,
            appName: "沙磁荟"
          },
          {
            appId: 37,
            appName: "新潼南"
          },
          {
            appId: 38,
            appName: "掌上大足"
          },
          {
            appId: 39,
            appName: "义渡热爱"
          },
          {
            appId: 40,
            appName: "智慧云阳"
          },
          {
            appId: 41,
            appName: "无线铜梁"
          },
          {
            appId: 42,
            appName: "测试重庆"
          },
          {
            appId: 50,
            appName: "全球渝商"
          },
          {
            appId: 51,
            appName: "汽车频道"
          },
          {
            appId: 52,
            appName: "手机cms"
          },
          {
            appId: 53,
            appName: "重庆市政府"
          },
          {
            appId: 54,
            appName: "应急救援频道"
          },
          {
            appId: 59,
            appName: "新重庆"
          },
          {
            appId: 60,
            appName: "投资渝中"
          },
          {
            appId: 61,
            appName: "网信办家园"
          },
          {
            appId: 62,
            appName: "重庆618"
          },
          {
            appId: 71,
            appName: "重庆联盟"
          },
          {
            appId: 1501,
            appName: "北碚融媒体中心家园"
          },
          {
            appId: 1502,
            appName: "两江新区"
          },
          {
            appId: 1503,
            appName: "高新区"
          },
          {
            appId: 1507,
            appName: "测试客户端名称11修改"
          },
          {
            appId: 1508,
            appName: "测试客户端222"
          },
          {
            appId: 1509,
            appName: "测试客户端3"
          }
        ]);
      }
    }
  },
  modules: {}
});
